<template>
  <picture>
    <template v-for="(size, index) in sizes" :key="index">
      <template v-if="lazy">
        <source
          v-if="size.media !== ''"
          :media="size.media"
          :data-srcset="getSrcset(index)"
          :data-aspectratio="ratio"
        />
        <img
          v-else
          class="lazyload"
          :alt="alt"
          :data-src="getSrc(index)"
          :data-aspectratio="ratio"
        />
      </template>

      <template v-else>
        <source
          v-if="size.media !== ''"
          :key="`source-${index}`"
          :media="size.media"
          :srcset="getSrcset(index)"
        />
        <img v-else :key="`img-${index}`" :alt="alt" :src="getSrc(index)" />
      </template>
    </template>
  </picture>
</template>

<script>
// sizes example
// [{
//   media: '(min-width: 1024px)',
//   resolutions: [{width: 1500, hash: ''},{width: 3000, hash: '' }]
// },{
//   media: '(min-width: 500px)',
//   resolutions: [{width: 1024, hash: ''},{width: 2048, hash: ''}]
// },{
//   media: '',
//   resolutions: [{width: 500, hash: ''}]
// }]
export default {
  name: 'media-picture',
  props: {
    filename: { type: String, required: true },
    alt: { type: String, default: '' },
    sizes: { type: Array, required: true },
    lazy: { type: Boolean, default: true },
    ratio: { type: String, default: '', required: false },
  },
  methods: {
    getSrcset(index) {
      let srcset = '';
      this.sizes[index].resolutions.forEach((resolution, i) => {
        const url = `${this.filename}?as=1&w=${resolution.width}&hash=${resolution.hash}`;
        const width = `${resolution.width}w`;
        const sep = i < this.sizes[index].resolutions.length - 1 ? ', ' : ' ';

        srcset += `${url} ${width}${sep}`;
      });
      return srcset;
    },

    getSrc(index) {
      return `${this.filename}?as=1&w=${this.sizes[index].resolutions[0].width}&hash=${this.sizes[index].resolutions[0].hash}`;
    },
  },
};
</script>
